export enum DataType {
  Primitive = 'primitive',
  Array = 'array',
  Record = 'record',
  Unknown = 'unknown'
}
